import axiosInstance from '../api';
import {
  VideoLikeRes,
  VideoLikesCountRes,
  VideoLikersRes,
} from './videoLikeApi.types';

/**
 * 動画に「いいね」する
 * @param video_id 動画ID
 * @returns API レスポンス
 */
export const likeVideo = async (video_id: string): Promise<VideoLikeRes> => {
  const response = await axiosInstance.post<VideoLikeRes>('/video-likes', { video_id }, {
    headers: { 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**
 * 動画の「いいね」を取り消す
 * @param video_id 動画ID
 * @returns API レスポンス
 */
export const unlikeVideo = async (video_id: string): Promise<VideoLikeRes> => {
  const response = await axiosInstance.delete<VideoLikeRes>('/video-likes', {
    params: { video_id }
  });
  return response.data;
};

/**
 * 動画の「いいね」数を取得する
 * @param video_id 動画ID
 * @returns いいね数情報
 */
export const getVideoLikesCount = async (video_id: string): Promise<VideoLikesCountRes> => {
  try {
    const response = await axiosInstance.get<{ count?: number; likesCount?: number }>('/video-likes/count', {
      params: { video_id }
    });

    let likesCount = 0;

    if (typeof response.data === 'object' && response.data !== null) {
      if ('count' in response.data && typeof response.data.count === 'number') {
        likesCount = response.data.count;
      } else if ('likesCount' in response.data && typeof response.data.likesCount === 'number') {
        likesCount = response.data.likesCount;
      }
    }

    return { likesCount };
  } catch (error) {
    console.error('[videoLikeApi] いいね数取得に失敗しました:', error);
    return { likesCount: 0 };
  }
};

/**
 * いいね状態を確認する
 * @param video_id 動画ID
 * @returns いいね済みかどうか
 */
export const checkLikeStatus = async (video_id: string): Promise<boolean> => {
  const response = await axiosInstance.get<{ is_liked: boolean }>('/video-likes/check', {
    params: { video_id }
  });
  return response.data.is_liked;
};

/**
 * 動画にいいねしたユーザー一覧を取得する
 * @param video_id 動画ID
 * @returns いいねしたユーザー一覧
 */
export const getVideoLikers = async (video_id: string): Promise<VideoLikersRes> => {
  const response = await axiosInstance.get<VideoLikersRes>('/video-likes/likers', {
    params: { video_id }
  });
  
  // nullの場合はundefinedに変換して型の互換性を確保
  return {
    likers: response.data.likers.map((user: { id: string; name: string; icon_path?: string | null }) => ({
      ...user,
      icon_path: user.icon_path === null ? undefined : user.icon_path
    }))
  };
}; 